import { GWEI_IN_WEI } from '@/constants'

export function formatGasPriceToGwei(gasPrice: bigint | undefined): number | undefined {
  if (!gasPrice) return

  return Number(gasPrice) / GWEI_IN_WEI
}
